// planetTagger.js
var PlanetTagger = pc.createScript('planetTagger');

PlanetTagger.attributes.add('cam', {type: 'entity'});
PlanetTagger.attributes.add('tScreen', {type: 'entity'});
PlanetTagger.attributes.add('tagTex', {type: 'asset', assetType: 'texture', array: true, title: 'tag textures'});

// initialize code called once per entity
PlanetTagger.prototype.initialize = function() {
    this.hideLoader = true;
    this.target = null;
    this.firstCall = false;
    this.theScreen = this.tScreen;
    this.sphere = null;
    this.targetScript = null;
    this.loadedStat = false;
};

PlanetTagger.prototype.worldSpaceToScreen = function(){
   
    this.sphere.center.copy(this.target.getPosition());
    if (!this.cam.camera.frustum.containsSphere(this.sphere)) {
        //this.entity.element.enabled = false;
        this.entity.children[1].element.enabled = false;
        this.entity.children[1].children[1].element.enabled = false;
        this.entity.children[2].element.enabled = false;
        this.entity.children[2].children[1].element.enabled = false;
        this.entity.children[3].enabled = false;
    } else {
        //this.entity.element.enabled = true;
        this.entity.children[1].element.enabled = true;
        this.entity.children[1].children[1].element.enabled = true;
        this.entity.children[2].element.enabled = true;
        this.entity.children[2].children[1].element.enabled = true;
        this.entity.children[3].enabled = true;
    }
    
    
    var worldPos = this.target.getPosition();
    var screenPos = new pc.Vec3();

    this.cam.camera.worldToScreen(worldPos, screenPos);
    
    var pixelRatio = this.app.graphicsDevice.maxPixelRatio;
    screenPos.x *= pixelRatio;
    screenPos.y *= pixelRatio;

    var screenEntity = this.entity.element.screen;
    var scale = screenEntity.screen.scale;
    
    var device = this.app.graphicsDevice;
    
    this.entity.setLocalPosition(screenPos.x / scale, (device.height - screenPos.y) / scale, 0);   
    this.entity.children[2].setLocalEulerAngles(0,0,screenPos.x/2);

};

PlanetTagger.prototype.setTarget = function(trgt){
    this.firstCall = true;
    this.target = trgt;
    this.sphere = new pc.BoundingSphere(this.target.getPosition(), 1);
    

    if(trgt.name === 'system'){

        this.entity.children[2].element.texture = this.tagTex[3].resource;
        this.entity.children[3].children[0].element.enabled = false;
        this.entity.children[3].children[1].element.enabled = false;
        this.entity.children[3].children[2].element.enabled = false;
        
    } else {
        
        if(trgt.children[1].script.planetGenerator){
            var pTyp = this.target.children[1].script.planetGenerator.planetType;
            if(pTyp == 'ROCK PLANET'){
                this.entity.children[2].element.texture = this.tagTex[2].resource;
            }
            
            if(pTyp == 'HABITABLE'){
                this.entity.children[2].element.texture = this.tagTex[0].resource;
            }
        }
        
        if(trgt.children[1].script.gasGiantGenerator){
            this.entity.children[2].element.texture = this.tagTex[1].resource;
        }
    }
};

// update code called every frame
PlanetTagger.prototype.update = function(dt) {
    if(this.firstCall){
        this.worldSpaceToScreen();

        if(this.target.children[1]){
           // console.log('target: ' + this.target.children[1].name);
         if(this.target.children[1].script.planetGenerator){
            var showNoShow_p = this.target.children[1].script.planetGenerator.isloaded; 
            this.entity.children[3].children[0].element.enabled = showNoShow_p;
            this.entity.children[3].children[1].element.enabled = showNoShow_p;
            this.entity.children[3].children[2].element.enabled = showNoShow_p;
        } else if(this.target.children[1].script.gasGiantGenerator){
            var showNoShow_g = this.target.children[1].script.gasGiantGenerator.isloaded; 
            this.entity.children[3].children[0].element.enabled = showNoShow_g;
            this.entity.children[3].children[1].element.enabled = showNoShow_g;
            this.entity.children[3].children[2].element.enabled = showNoShow_g;
        }
        }

    }
};

// swap method called for script hot-reloading
// inherit your script state here
// PlanetTagger.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

